<template>
  <div>
    <v-text-field
      v-model="libelleAffiche"
      dense
      filled
      hide-details
      readonly
      append-icon="search"
      @click="textFieldClicked"
      :placeholder="libelle"
    >
    </v-text-field>
    <v-dialog v-model="modal" scrollable>
      <v-card>
        <v-card-title>
          {{ titre }}
        </v-card-title>
        <v-card-text v-if="'personnemorale' === type">
          <v-row>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasource"
                attr="raisonSociale"
                i18n="recherche.rechercheSimple.personneMorale.search.raisonSociale"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <search-by
                :datasource="datasource"
                attr="departement"
                i18n="recherche.rechercheSimple.personneMorale.search.departement"
              />
            </v-col>
          </v-row>
          <datasource-table style="height:480px;" :datasource="datasource">
            <template #item.nomUsuel="{item}">
              <a @click="select(item)">
                {{ item.nomUsuel }}
              </a>
            </template>
            <template #item.raisonSociale="{item}">
              <a @click="select(item)">
                {{ item.raisonSociale }}
              </a>
            </template>
          </datasource-table>
        </v-card-text>

        <v-card-text
          v-if="'personnephysique' === type || 'participant' === type"
        >
          <v-row>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasource"
                attr="nom"
                i18n="recherche.rechercheSimple.personnePhysique.search.nom"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasource"
                attr="prenom"
                i18n="recherche.rechercheSimple.personnePhysique.search.prenoms"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <search-by
                :datasource="datasource"
                attr="raisonSociale"
                i18n="recherche.rechercheSimple.personnePhysique.search.raisonSociale"
              />
            </v-col>
          </v-row>
          <datasource-table style="height:480px;" :datasource="datasource">
            <template #item.nom="{item}">
              <a @click="select(item)">
                {{ item.nom }}
              </a>
            </template>
            <template #item.prenoms="{item}">
              <a @click="select(item)">
                {{ item.prenoms }}
              </a>
            </template>
          </datasource-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeModal" text>
            {{ $t('button.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Datasource from '@/utils/datasource';

export default {
  props: {
    type: {
      type: String,
    },
    libelle: {
      type: String,
    },
    value: {
      type: Object,
    },
  },
  computed: {
    titre() {
      if ('personnemorale' === this.type) {
        return 'Sélection de personne morale';
      } else if ('personnephysique' === this.type) {
        return 'Sélection de personne physique';
      } else if ('participant' === this.type) {
        return 'Sélection de participant';
      }

      return null;
    },
  },

  data() {
    const value = this.value || {};

    var datasource = null;

    if ('personnemorale' === this.type) {
      datasource = new Datasource('recherche/simple/personne-morale', {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nomUsuel'],
        descending: [false],
        labelNamespace: 'recherche.rechercheSimple.personneMorale.list',
        args: {
          actif: true,
        },
        fields: [
          // ...this.fieldName,
          {
            value: 'nomUsuel',
            sortable: true,
          },
          {
            value: 'raisonSociale',
            sortable: true,
          },
          {
            value: 'departement',
            sortable: false,
          },
          {
            value: 'ville',
            sortable: false,
          },
          {
            value: 'telephone',
            sortable: false,
          },
        ],
      });
    } else if (
      'personnephysique' === this.type ||
      'participant' === this.type
    ) {
      datasource = new Datasource('recherche/simple/contact', {
        page: 1,
        rowsPerPage: 20,
        sortBy: ['nom'],
        descending: [false],
        labelNamespace: 'recherche.rechercheSimple.personnePhysique.list',
        args: {},
        fields: [
          // ...this.fieldName,
          {
            value: 'nom',
            sortable: true,
          },
          {
            value: 'prenoms',
            sortable: true,
          },
          {
            value: 'raisonSociale',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.personneMorale',
            ),
          },

          {
            value: 'fonction',
            sortable: true,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.fonction',
            ),
          },
          {
            value: 'telephone',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.telephone',
            ),
          },
          {
            value: 'mail',
            sortable: false,
            text: this.$t(
              'recherche.rechercheSimple.personnePhysique.list.headers.mail',
            ),
          },
        ],
      });
    }

    return {
      modal: false,
      libelleAffiche: value.libelle || '',
      valeur: value,
      datasource,
    };
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.libelleAffiche = null;
        this.datasource.clear();
      }
    },
  },
  methods: {
    select(item) {
      this.modal = false;

      const valeur = {
        id: item.id,
        libelle: null,
      };

      if (this.type === 'personnemorale') {
        valeur.libelle = item.raisonSociale;
      } else if ('personnephysique' === this.type) {
        //on veut l'id de la personne physique et non pas celle du contact dans ce cas
        valeur.id = item.idPersonnePhysique;
        valeur.libelle = item.nom + ' ' + item.prenoms;
      } else if ('participant' === this.type) {
        valeur.libelle = item.nom + ' ' + item.prenoms;
      }

      this.valeur = valeur;
      this.libelleAffiche = valeur.libelle;
      this.$emit('input', valeur);
    },
    textFieldClicked() {
      this.modal = true;
      this.datasource.debouncedRefresh();
    },
    closeModal() {
      this.modal = false;
    },
  },
};
</script>
